module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "rules": {},
      "label-width": "100px"
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "赛区",
      "prop": "name"
    }
  }, [_vm._v(_vm._s(_vm.formData.saiqu_name))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单位",
      "prop": "name"
    }
  }, [_vm._v(_vm._s(_vm.formData.danwei))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "队伍名称",
      "prop": "name"
    }
  }, [_vm._v(_vm._s(_vm.formData.danwei + _vm.formData.mingcheng + '啦啦队'))])], 1)], 1), _vm._v(" "), _c('el-divider', [_vm._v("优秀教练员申报")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "优秀教练员"
    }
  }, [_c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.showJiaolianPicker = true
      }
    }
  }, [_vm._v("请选择教练员 "), _c('i', {
    staticClass: "el-icon-arrow-right"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.jiaolian.length > 0),
      expression: "formData.jiaolian.length>0"
    }]
  }, _vm._l((_vm.formData.jiaolian), function(jiaolian, index) {
    return _c('div', {
      key: index,
      staticClass: "memberLi"
    }, [_c('el-tag', {
      key: index,
      attrs: {
        "round": "",
        "closable": "",
        "type": "primary"
      },
      on: {
        "close": function($event) {
          return _vm.formData.jiaolian.splice(index, 1)
        }
      }
    }, [_vm._v(" " + _vm._s(jiaolian.name) + " " + _vm._s(jiaolian.num) + "\n                ")])], 1)
  }), 0)])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("立即申报\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('SubjectCaipanPicker', {
    attrs: {
      "show": _vm.showCaipanPicker,
      "limit": 5,
      "options": _vm.formData.caipan_options,
      "defaultValue": _vm.formData.caipan
    },
    on: {
      "onChange": _vm.onCaipanChange,
      "onClose": function($event) {
        _vm.showCaipanPicker = false
      },
      "onConfirm": _vm.onCaipanConfirm
    }
  }), _vm._v(" "), _c('SubjectJiaolianPicker', {
    attrs: {
      "show": _vm.showJiaolianPicker,
      "limit": 5,
      "options": _vm.formData.jiaolian_options,
      "defaultValue": _vm.formData.jiaolian
    },
    on: {
      "onChange": _vm.onJiaolianChange,
      "onClose": function($event) {
        _vm.showJiaolianPicker = false
      },
      "onConfirm": _vm.onJiaolianConfirm
    }
  }), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e184b38","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormJiaolianCaipan.vue
// module id = 1397
// module chunks = 0